import { ComponentType } from 'react';

import { BillToAddressCard } from '../../../../../../components/cards/company';
import { AdditionalAttachmentCard } from '../../../../../../components/cards/financial/AttachmentCard';
import PrivacyPolicyCard from '../../../../../../components/cards/financial/PrivacyPolicyCard';
import CompanyPage from '../../../../../../features/CompanyPage';
import { CARD_CATEGORIES } from '../../../../../../shared/cardConfig/constants';
import { ATTACHMENT_FIELDS, BILL_TO_ADDRESS_FIELDS } from '../../../../../../shared/fieldConfig/constants';
import { PAGE_ROUTES } from '../../../../../../utils/constants';

// ----------------- Types -----------------
export interface Field {
  key: string;
  required?: boolean;
}

export interface Card {
  key: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  Component: ComponentType<any>;
  fields?: Field[];
  hideSameAs?: boolean;
  fieldWrapper?: string;
  isCardOptional?: boolean;
  sameAsFields?: string[];
}

export interface Page {
  route: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  Component: ComponentType<any>;
  cards?: Card[];
}

// ----------------- BillTo Page Template -----------------
const billToPageTemplate: Page = {
  route: PAGE_ROUTES.company,
  Component: CompanyPage,
  cards: [
    {
      key: CARD_CATEGORIES.billTo,
      Component: BillToAddressCard,
      hideSameAs: true,
      fields: [
        { key: BILL_TO_ADDRESS_FIELDS.address },
        { key: BILL_TO_ADDRESS_FIELDS.taxNumber2 },
        { key: BILL_TO_ADDRESS_FIELDS.taxNumber3 }
      ]
    },
    {
      key: CARD_CATEGORIES.additionalAttachmentCard,
      Component: AdditionalAttachmentCard,
      fields: [{ key: ATTACHMENT_FIELDS.additionalAttachment }]
    },
    {
      key: CARD_CATEGORIES.privacyPolicy,
      Component: PrivacyPolicyCard
    }
  ]
};

const pages: Page[] = [billToPageTemplate];

export default pages;